import DottedHalfNote from "./DottedHalfNote"
import DottedHalfRest from "./DottedHalfRest"
import HalfNote from "./HalfNote"
import HalfRest from "./HalfRest"
import QuarterNote from "./QuarterNote"
import QuarterRest from "./QuarterRest"
import WholeNote from "./WholeNote"
import WholeRest from "./WholeRest"

const Note = ({type, x, y, sharp, natural}) => {
    if (type == 'QuarterNote') {
        return (<QuarterNote x={x} y={y} width={22} height={60} sharp={sharp} natural={natural}/>)
    }
    if (type == 'HalfNote') {
        return (<HalfNote x={x} y={y} width={22} height={60} sharp={sharp} natural={natural} />)
    }
    if (type == 'DottedHalfNote') {
        return (<DottedHalfNote x={x} y={y} width={22} height={60} sharp={sharp} natural={natural}/>)
    }
    if (type == 'WholeNote') {
        return (<WholeNote x={x} y={y} width={22} sharp={sharp} natural={natural} />)
    }
    if (type == 'QuarterRest') {
        return (<QuarterRest x={x} y={11 + 50} width={22} height={60} />)
    }
    if (type == 'HalfRest') {
        return (<HalfRest x={x} y={31 + 50} width={22} height={11} />)
    }
    if (type == 'DottedHalfRest') {
        return (<DottedHalfRest x={x} y={31 + 50} width={22} height={11}/>)
    }
    if (type == 'WholeRest') {
        return (<WholeRest x={x} y={21 + 50} width={22} height={11} />)
    }
}

export default Note